var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyHandbook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "89px",
    height: "89px",
    viewBox: "0 0 89 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MyHandbook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.2977 46.9726 0.2977 46.9726 43 0 43"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.3509 0.891 17.4329 0.891 17.4329 45.6326 0.3509 45.6326"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MyHandbook",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(21.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 9.109400)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8376,0.2977 L38.4326,0.2977 L38.4326,4.6637 L42.7026,4.5677 L42.7026,32.3247 L32.0266,32.3247 C29.7116,32.3277 27.4616,33.0907 25.6216,34.4977 C25.6216,35.6757 24.6656,36.6317 23.4856,36.6317 C22.3076,36.6317 21.3516,35.6757 21.3516,34.4977 C19.5106,33.0917 17.2606,32.3287 14.9456,32.3247 L4.2706,32.3247 L4.2706,4.5677 L14.9456,4.5677 C18.4836,4.5677 21.3516,7.4357 21.3516,10.9727 L21.3516,2.8337 C21.3516,2.5667 21.3776,2.3327 21.3886,2.0787 C21.3736,2.1947 21.3516,2.3077 21.3516,2.4327 L21.3516,2.4857 C19.5136,1.0737 17.2636,0.3047 14.9456,0.2977 L2.1346,0.2977 C0.9556,0.2977 -0.0004,1.2537 -0.0004,2.4327 L-0.0004,34.4597 C-0.0004,35.6387 0.9556,36.5947 2.1346,36.5947 L14.9456,36.5947 C17.8556,36.6087 20.3886,38.5817 21.1166,41.3987 C21.3596,42.3407 22.2096,42.9997 23.1816,43.0007 L23.7906,43.0007 C24.7636,42.9997 25.6126,42.3407 25.8566,41.3987 C26.5836,38.5817 29.1176,36.6087 32.0266,36.5947 L44.8376,36.5947 C46.0166,36.5947 46.9726,35.6387 46.9726,34.4597 L46.9726,2.4327 C46.9726,1.2537 46.0166,0.2977 44.8376,0.2977",
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(21.000000, 0.109400)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1619,32.7006 C10.8639,32.6806 7.3879,33.0336 4.6209,34.8696 L4.6209,11.8336 C4.6209,7.5186 5.8689,5.5066 13.1619,5.2016 L13.1619,32.7006 Z M15.2969,0.8906 C8.2569,0.8906 0.7789,1.7176 0.3889,11.0786 C0.3779,11.3326 0.3509,11.5666 0.3509,11.8336 L0.3509,19.9726 L0.3509,43.4976 C0.3509,44.6766 1.3079,45.6326 2.4859,45.6326 C3.6649,45.6326 4.6209,44.6766 4.6209,43.4976 C4.6209,41.4216 5.2149,39.8986 6.4359,38.8426 C8.8719,36.7346 13.4329,36.8586 14.9799,37.0836 C15.5969,37.1756 16.2199,36.9956 16.6899,36.5906 C17.1609,36.1846 17.4329,35.5936 17.4329,34.9716 L17.4329,13.6636 L17.4329,9.2976 L17.4329,3.0256 C17.4329,1.8466 16.4759,0.8906 15.2969,0.8906 L15.2969,0.8906 Z",
    id: "Fill-4",
    fill: "#FCBC00",
    mask: "url(#mask-4)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyHandbook);
export default __webpack_public_path__ + "static/media/my-handbook.95c1f59b9c84e297ea13d4f683430c6f.svg";
export { ForwardRef as ReactComponent };